import React from 'react';
import { useTranslation } from '@whoop/i18n/lang/client';
import { useUpgradeFlowButtonLogic } from './useUpgradeFlowButtonLogic';
import { CartButtons } from './CartButtons';
import { UPGRADE_STEPS } from '@/lib/constants/maverick';
import { useGetCurrentPageMaverick } from '@/hooks/useGetCurrentPageMaverick';
import { CartButtonVariants } from './CartCTAButtons';
import { useSiteStore } from '@/store/SiteStoreProvider';
import { useShallow } from 'zustand/react/shallow';
import { EXPERIMENT_UPCYCLE_MODAL_ADD_GIFT_KIT } from '@/lib/constants/experiments';
interface UpgradeFlowButtonsProps {
  showOnlyPrimaryButton: boolean;
  variant: CartButtonVariants;
}
export function UpgradeFlowButtons({
  variant,
  showOnlyPrimaryButton
}: UpgradeFlowButtonsProps) {
  const {
    t
  } = useTranslation('cart');
  const {
    experimentVariants,
    setIsCartOpen
  } = useSiteStore(useShallow(state => ({
    experimentVariants: state.experimentVariants,
    setIsCartOpen: state.setIsCartOpen
  })));
  const page = useGetCurrentPageMaverick();
  const isUpgradeOptionsPage = page === UPGRADE_STEPS.OPTIONS;
  const isUpgradeUpcyclePage = page === UPGRADE_STEPS.UPCYCLE;
  const isUpgradeAccessoriesPage = page === UPGRADE_STEPS.ACCESSORIES;
  const isUpcycleExperimentVariant = experimentVariants[EXPERIMENT_UPCYCLE_MODAL_ADD_GIFT_KIT] === 'experiment';
  const {
    buttonsVariant,
    primaryButtonActionVariants,
    secondaryButtonActionVariants,
    primaryButtonLabelVariants,
    secondaryButtonLabelVariants,
    onContinueToCheckout
  } = useUpgradeFlowButtonLogic({
    buttonsVariant: variant,
    isUpcycleExperimentVariant
  });

  // Override actions for upgrade flow specific variants
  const upgradeFlowPrimaryButtonActions = {
    ...primaryButtonActionVariants,
    chooseUpgradeOption: () => setIsCartOpen(false),
    chooseUpcycleOption: () => setIsCartOpen(false)
  };
  const {
    primaryButtonLabel,
    primaryButtonAction
  } = isUpgradeOptionsPage || isUpgradeUpcyclePage ? {
    primaryButtonLabel: primaryButtonLabelVariants[buttonsVariant],
    primaryButtonAction: upgradeFlowPrimaryButtonActions[buttonsVariant]
  } : {
    primaryButtonLabel: t('continueToCheckout'),
    primaryButtonAction: onContinueToCheckout
  };

  // Determine if we should show secondary button
  const shouldShowSecondaryButton = isUpgradeUpcyclePage && Boolean(secondaryButtonLabelVariants[buttonsVariant]) && Boolean(secondaryButtonActionVariants[buttonsVariant]);
  return <CartButtons primaryButtonLabel={primaryButtonLabel} primaryButtonAction={primaryButtonAction!} showSecondaryButton={shouldShowSecondaryButton} secondaryButtonLabel={secondaryButtonLabelVariants[buttonsVariant]} secondaryButtonAction={secondaryButtonActionVariants[buttonsVariant]} showKeepShoppingButton={isUpgradeAccessoriesPage} keepShoppingAction={() => setIsCartOpen(false)} keepShoppingLabel={t('keepShopping')} showOnlyPrimaryButton={showOnlyPrimaryButton} data-sentry-element="CartButtons" data-sentry-component="UpgradeFlowButtons" data-sentry-source-file="UpgradeFlowButtons.tsx" />;
}